/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { DownloadBaseDto, QboSettingsModelDto, QfxSettingsModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class DownloadClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Download
   * @name DownloadPost
   * @summary Generates the requested download payload based on the specified page identifier and filter model.
   * @request POST:/download
   */
  downloadPost = (data: DownloadBaseDto, params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/download`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Download
   * @name DownloadGetQboSettings
   * @summary Gets the QuickBooks Online (QBO) settings for the current context.
   * @request GET:/download/qboSettings
   */
  downloadGetQboSettings = (params: RequestParams = {}) =>
    this.http.request<QboSettingsModelDto, any>({
      path: `/download/qboSettings`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Download
   * @name DownloadGetQfxEnabledFlag
   * @summary Gets the QFX enabled flag for the company (if configured).
   * @request GET:/download/getQfxEnabledFlag
   */
  downloadGetQfxEnabledFlag = (params: RequestParams = {}) =>
    this.http.request<QfxSettingsModelDto, any>({
      path: `/download/getQfxEnabledFlag`,
      method: "GET",
      format: "json",
      ...params,
    });
}
